:host {
  --text-color: #333;
  --link-color: #007bff;
  --code-bg: #f8f9fa;
  --code-color: #e83e8c;
  --code-border: #e9ecef;
}

.text-renderer {
  color: var(--text-color);
  line-height: 1.6;
  word-wrap: break-word;
}

.text-renderer a {
  color: var(--link-color);
  text-decoration: none;
  border-bottom: 1px solid transparent;
  transition: border-color 0.2s;
}

.text-renderer a:hover {
  border-bottom-color: var(--link-color);
}

.text-renderer code {
  background: var(--code-bg);
  color: var(--code-color);
  padding: 2px 4px;
  border-radius: 3px;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 0.9em;
  border: 1px solid var(--code-border);
}
